<template>
  <v-layout column>
    <v-layout>
      <v-flex xs6>
        <v-select prepend-icon="$vuetify.icons.parkingLot" label="通行园区选择"
                  clearable :items="form.parkSelect" item-text="name" item-value="id" v-model="record.park" chips></v-select>
      </v-flex>
      <v-flex xs6>
        <l-autocomplete
          :get-data="searchChargingRule"
          item-text="name"
          label="计费规则选择"
          prepend-icon="$vuetify.icons.code"
          v-model="record.chargingRule"
        ></l-autocomplete>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
  export default {
    name: 'payRule',
    props: {
      record: {
        type: Object,
        default: function () {
          return {}
        }
      }
    },
    data () {
      return {
        form: {
          parkSelect: []
        }
      }
    },
    created () {
      this.init()
    },
    methods: {
      init () {
        let parkList = this.$store.state.parkingLot.parkingLotList
        for (let i = 0; i < parkList.length; i++) {
          this.form.parkSelect.push(parkList[i])
        }
      },
      async searchChargingRule (val) {
        try {
          let {items} = await this.$store.dispatch('charging/getRuleConfigList', {
            pagination: {page: 1, rowsPerPage: 10},
            search: {key: 'name', value: val},
          })
          return items
        }
        catch (e) {
          this.$L.alert('error', {message: e.message})
          return []
        }
      }
    },
    watch: {
      'record.park' () {
        this.record.controllerSelect = []
        let controllerList = this.$store.state.parkingLot.controllerList
        for (let i = 0; i < controllerList.length; i++) {
          if (controllerList[i].parkingLot.id === this.record.park) {
            this.record.controllerSelect.push(controllerList[i])
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
